export const ANALYTICS_LEGACY_FLAGS = {
  appAnalyticsEvents: true,
  appDailyRollups: true,
  campaignTrafficEvents: true,
  campaignAttributionEvents: true,
  usageDailyRollups: true,
};

export const isLegacyAnalyticsEnabled = (key) =>
  ANALYTICS_LEGACY_FLAGS[key] !== false;
